import React from "react";
import axios from 'axios';
import "antd/dist/antd.css";
import ENVIRONMENTS from '../../../../environments'
import '@ant-design/compatible/assets/index.css';
import {calcTotalModelsWorked, getNeedToModelString, exportToCSV, generateExportFilename} from '../../Utilities'
import {  Row, Col, Select, Typography, Table, DatePicker, Tooltip, Tabs, Button } from "antd";
import { LoadingOutlined, InfoCircleOutlined } from '@ant-design/icons';
import DottedLoader from "../../DottedLoader";
import moment from 'moment';

const { Option } = Select;
const { Text } = Typography;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const DATE_FORMAT = 'MM/DD/YYYY';

class InvoicingTimeLog extends React.Component {
  state = {
    profile_id: '',
    artist_username: '',
    profile_name: '',
    billing_type: '',
    hourly_rate: "",
    agency_admin: false,
    agency_artist: false,
    availability: {},
    data_source: [],
    invoice_summary: {},
    artist_data_fetched: false,
    // Invoicing attributes
    start_date: moment().startOf('month').format(DATE_FORMAT),
    end_date: moment().endOf('month').format(DATE_FORMAT),
    invoice_data: [],
    filtered_invoice_date: [],
    loading_invoice_date: false,
    model_type_filter: '',
    total_hours_worked: 0,
    total_models_worked: 0,
    total_amount_invoiced: 0,
    required_invoicing_data: 'all',
    // Non-approved tab
    non_approved_data: [],
    non_approved_summary: {},
    loading_non_approved: false,
    non_approved_model_type_filter: '',
    filtered_non_approved_data: [],
    activeTab: 'approved',
  };

  componentDidMount() {
    axios.post(ENVIRONMENTS.GET_ARTIST_PROFILE, {
      artist_username: localStorage.getItem('username')
    })
      .then(res => {
        this.setState({
          profile_id: res.data['artist_id'],
          artist_username: res.data['artist_username'],
          profile_name: res.data['profile_name'],
          is_super_artist: res.data['is_superartist'],
          billing_type: res.data['billing_type'],
          hourly_rate: res.data['hourly_rate'],
          availability: res.data['availability'],
          agency_admin: res.data['agency_admin'],
          agency_artist: res.data['agency_artist'],
          artist_data_fetched: true
        }, () =>{
          this.fetchArtistInvoice();
        })
      })
  }

  // --- Approved Tab Logic (existing) ---
  invoiceSummary = () => {
    let total_hours = 0;
    let total_amount = 0;
    let total_models = 0;

    this.state.invoice_data.map((ele) => {
      total_hours += parseFloat(ele['hours']) || 0;
    })
    total_hours = total_hours.toFixed(2);
    total_models = calcTotalModelsWorked(this.state.invoice_data);

    if(this.state.billing_type == 'hourly' && this.state.hourly_rate)
      total_amount = total_hours * this.state.hourly_rate;
    else if(this.state.billing_type == 'per_model' && this.state.hourly_rate)
      total_amount = total_models * this.state.hourly_rate;
    
    total_amount = total_amount.toFixed(2);
    this.setState({
      total_amount_invoiced: total_amount,
      total_hours_worked: total_hours,
      total_models_worked: total_models
    })
  }

  onCalenderChange = (date_values) => {
    if (date_values && date_values[0] && date_values[1]) {
        this.setState({
          start_date: date_values[0].format(DATE_FORMAT),
          end_date: date_values[1].format(DATE_FORMAT)
        }, () => {this.fetchArtistInvoice()})
    }
  }

  fetchArtistInvoice = () => {
    let payload = {
      'start_date': moment(this.state.start_date).format('YYYY-MM-DD'),
      'end_date': moment(this.state.end_date).format('YYYY-MM-DD'),
      'artist_usernames': [this.state.artist_username],
      'artist_invoice': true,
    }
    this.setState({
      loading_invoice_date: true
    })
    axios.post(ENVIRONMENTS.GET_ARTIST_INVOICE, payload)
    .then(res => {
      this.setState({
        invoice_data: res.data['invoice_data'],
        filtered_invoice_date: res.data['invoice_data'],
        invoice_summary: res.data['summary'],
        loading_invoice_date: false
      }, ()=> {this.filterInvoiceData()})
    })
  }

  getInvoiceColumns = () => [
    {
      title: <span className="manrope f-16 black-14">Model ID</span>,
      dataIndex: 'model_id',
      key: 'model_id',
      render: text => <span  className="manrope f-14">{text}</span>,
    },
    {
      title: <span className="manrope f-16 black-14">Model Name</span>,
      dataIndex: 'model_name',
      key: 'model_name',
      render: text => <span  className="manrope f-14 ">{text}</span>,
    },
    {
      title: <span className="manrope f-16 black-14">Model Type</span>,
      dataIndex: 'model_type',
      key: 'model_type',
      render: (text, index) => <span className="manrope f-14">{text} {index['variant_of'] != null ? ' Variation' : ''} {getNeedToModelString(index)}</span>,
    },
    {
        title: <span className="manrope f-16 black-14">Task Type</span>,
        dataIndex: 'request_type',
        key: 'request_type',
        render: text => <span  className="manrope f-14">{text}</span>,
    },
    {
      title: <span className="manrope f-16 black-14">Date</span>,
      dataIndex: 'date',
      key: 'date',
      render: text => <span  className="manrope f-14 ">{text || 'N/A'}</span>,
    },
    {
        title: <span className="manrope f-16 black-14">Hours Worked</span>,
        dataIndex: 'hours',
        key: 'hours',
        render: text => <span className="manrope f-14">{parseFloat(text || 0) + ' Hours'}</span>,
    },
  ];

  getCSVExportColumns = () => [
    {
      title: 'Model ID',
      dataIndex: 'model_id',
      key: 'model_id',
    },
    {
      title: 'Model Name',
      dataIndex: 'model_name',
      key: 'model_name',
    },
    {
      title: 'Model Type',
      dataIndex: 'model_type',
      key: 'model_type',
    },
    {
      title: 'Task Type',
      dataIndex: 'request_type',
      key: 'request_type',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Hours Worked',
      dataIndex: 'hours',
      key: 'hours',
    },
  ];

  filterInvoiceData = () => {
    let filtered_data = [];
    let filters = {};
    if(this.state.model_type_filter != ''){
      filters['model_type'] = this.state.model_type_filter;
    }
    filtered_data = this.state.invoice_data.filter(function(item) {
      for (var key in filters) {
        if (item[key] != filters[key])
          return false;
      }
      return true;
    });

    this.setState({filtered_invoice_date: filtered_data})
  }

  // --- Non-Approved Tab Logic ---
  fetchNonApprovedData = () => {
    this.setState({ loading_non_approved: true });
    axios.post(ENVIRONMENTS.GET_ARTIST_NON_APPROVED_DATA, {
      artist_username: this.state.artist_username
    })
    .then(res => {
      this.setState({
        non_approved_data: res.data['non_approved_items'] || [],
        filtered_non_approved_data: res.data['non_approved_items'] || [],
        non_approved_summary: res.data['summary'] || {},
        loading_non_approved: false
      }, () => this.filterNonApprovedData());
    })
    .catch(() => this.setState({ loading_non_approved: false }));
  }

  filterNonApprovedData = () => {
    let filtered_data = [];
    let filters = {};
    if(this.state.non_approved_model_type_filter != ''){
      filters['model_type'] = this.state.non_approved_model_type_filter;
    }
    filtered_data = this.state.non_approved_data.filter(function(item) {
      for (var key in filters) {
        if (item[key] != filters[key])
          return false;
      }
      return true;
    });
    this.setState({filtered_non_approved_data: filtered_data})
  }

  getSummarySection = (summary, isSuperArtist, hourly_rate, billing_type, isNonApproved = false, agency_admin = false, agency_artist = false) => (
    <Row style={{display: 'block'}}>
      <span className="manrope f-20">Work Summary</span>
      <Row className="artist-details-info" style={{marginBottom: 20, marginTop :20}}>
        <Col span={6}>
          <div className="manrope f-16">
            <p className="artist-details-heading">Total Hours Worked</p>
            <p className="artist-details-value">{summary['hours'] ? summary['hours'] + ' Hours' : '0 Hours'}</p>
          </div>
        </Col>
        <Col span={6}>
          <div className="manrope f-16">
            <p className="artist-details-heading">Total Models Made
              {((summary['spaces'] || 0) + (summary['space_variants'] || 0) + (summary['product_variants'] || 0) + (summary['products'] || 0) + (summary['materials'] || 0) + (summary['complaints'] || 0)) > 0 ?
                <Tooltip title={<span className='manrope f-12 white'>
                  {summary['spaces'] > 0 ? <span style={{display: 'block', marginBottom: 1, marginTop: 1}}>Spaces: {summary['spaces']}</span> : ''}
                  {summary['space_variants'] > 0 ? <span style={{display: 'block', marginBottom: 1, marginTop: 1}}>Space Variants: {summary['space_variants']}</span> : ''}
                  {summary['products'] > 0 ? <span style={{display: 'block', marginBottom: 1, marginTop: 1}}>Products: {summary['products']}</span> : ''}
                  {summary['product_variants'] > 0 ? <span style={{display: 'block', marginBottom: 1, marginTop: 1}}>Product Variants: {summary['product_variants']}</span> : ''}
                  {summary['complaints'] > 0 ? <span style={{display: 'block', marginBottom: 1, marginTop: 1}}>Complaints: {summary['complaints']}</span> : ''}
                  {summary['materials'] > 0 ? <span style={{display: 'block', marginBottom: 1, marginTop: 1}}>Materials: {summary['materials']}</span> : ''}
                </span>}>
                  <InfoCircleOutlined style={{marginLeft: 3}}/>
                </Tooltip> : ''}
            </p>
            <p className="artist-details-value">{((summary['spaces'] || 0) + (summary['space_variants'] || 0) + (summary['product_variants'] || 0) + (summary['products'] || 0) + (summary['materials'] || 0) + (summary['complaints'] || 0))}</p>
          </div>
        </Col>
        {agency_artist && !agency_admin ? 
        "" :
          <>
          <Col span={6}>
            <div className="manrope f-16">
              <p className="artist-details-heading">Billing Rate</p>
              <p className="artist-details-value" style={{fontSize: 14, marginBottom: 7}}>{hourly_rate ? ('$' + hourly_rate + (billing_type === 'hourly' ? ' / hour' : billing_type === 'per_model' ? ' / model' : '')) : 'N/A'}</p>
              <p className="artist-details-value" style={{fontSize: 14, marginBottom: 7}}>{hourly_rate && billing_type == 'per_model' ? '$' + (hourly_rate / 2).toFixed(1) + ' / variant' : ''}</p>
              <p className="artist-details-value" style={{fontSize: 14, marginBottom: 7}}>{hourly_rate && billing_type == 'per_model' ? '$' + (hourly_rate / 2).toFixed(1) + ' / material' : ''}</p>
            </div>
          </Col>
          <Col span={6}>
            <div className="manrope f-16">
              <p className="artist-details-heading">{isNonApproved ? 'Total Amount Pending' : 'Total Amount Invoiced'}</p>
              <p className="artist-details-value">{summary['amount'] || '$0.0'}</p>
            </div>
          </Col>
          </>
      }
      </Row>
    </Row>
  );

  handleTabChange = (activeKey) => {
    this.setState({ activeTab: activeKey });
    if (activeKey === 'nonapproved' && this.state.non_approved_data.length === 0) {
      this.fetchNonApprovedData();
    }
  }

  // Export handler - handles both approved and non-approved data
  handleExportData = (exportType) => {
    const isApproved = exportType === 'approved';
    const filenamePrefix = isApproved ? 'Artist_Invoice' : 'Pending_Items';
    const data = isApproved ? this.state.filtered_invoice_date : this.state.filtered_non_approved_data;

    // Only append dates for approved data, not for non-approved
    const filename = isApproved
      ? generateExportFilename(`${filenamePrefix}_${this.state.artist_username}`, this.state.start_date, this.state.end_date)
      : `${filenamePrefix}_${this.state.artist_username}`;

    const columns = this.getCSVExportColumns();

    exportToCSV(filename, columns, data, {
      valueFormatter: (value, row, col) => {
        // Format specific columns for CSV export
        if (col.dataIndex === 'hours') {
          return parseFloat(value || 0);
        }
        if (col.dataIndex === 'model_type') {
          return `${value}${row['variant_of'] != null ? ' Variation' : ''}${getNeedToModelString(row)}`;
        }
        if (col.dataIndex === 'date') {
          return value || 'N/A';
        }
        return value;
      }
    });
  }

  render() {
    if (!this.state.artist_data_fetched) return <DottedLoader/>;
    return (
      <Tabs activeKey={this.state.activeTab} onChange={this.handleTabChange}>
        <TabPane tab="Approved Invoices" key="approved">
          {/* Artist Time Log */}
          <Row align="middle" justify="space-between" style={{marginTop: 20, marginBottom: 10}}>
            <Col><p className="manrope f-24">Invoice</p></Col>
            <Col style={{display: 'flex', gap: 16, justifyContent: 'flex-end'}}>
              <RangePicker style={{marginRight: 8}} size={"large"} defaultValue={[moment(this.state.start_date, DATE_FORMAT), moment(this.state.end_date, DATE_FORMAT)]}
                format={DATE_FORMAT} className="date-picker" popupStyle={{fontFamily: 'Manrope', fontSize: 14,color:"#40a9ff",background:"#e6efff" }} placeholder={['Date (From)', 'Date (To)']}
                value={[moment(this.state.start_date, DATE_FORMAT), moment(this.state.end_date, DATE_FORMAT)]}
                onCalendarChange={val => this.onCalenderChange(val)}/>
              <Select placeholder="Model Type: All" size={"large"} style={{width: 180}} onChange={val => {this.setState({model_type_filter: val}, ()=>this.filterInvoiceData())}}>
                <Option className="manrope f-14 black-55 select-view" value="">Model Type: All</Option>
                <Option className="manrope f-14 black-55 select-view" value="Space">Space</Option>
                <Option className="manrope f-14 black-55 select-view" value="Product">Product</Option>
                <Option className="manrope f-14 black-55 select-view" value="Material">Material</Option>
                {this.state.is_super_artist ?
                  <Option className="manrope f-14 black-55 select-view" value="Complaint">Complaint</Option>
                  : ""}
              </Select>
              <Button 
                className="save-button okay font-16"
                onClick={() => this.handleExportData('approved')}
                disabled={this.state.filtered_invoice_date.length === 0}
                style={{color: 'white'}}
              >
                Export CSV
              </Button>
            </Col>
          </Row>
          <Col className='items-table' span={24}>
            <Table loading={{indicator: <LoadingOutlined/>, spinning: this.state.loading_invoice_date}} columns={this.getInvoiceColumns()} dataSource={this.state.filtered_invoice_date} pagination={{ pageSize: 7}}/>
          </Col>
          {/* Artist Work Summary */}
          {this.getSummarySection(this.state.invoice_summary, this.state.is_super_artist, this.state.hourly_rate, this.state.billing_type, false, this.state.agency_admin, this.state.agency_artist)}
        </TabPane>
        <TabPane tab="Items Pending Approval" key="nonapproved">
          <Row align="middle" justify="space-between" style={{marginTop: 20, marginBottom: 10}}>
            <Col><p className="manrope f-24">Items Pending Approval</p></Col>
            <Col style={{display: 'flex', gap: 16, justifyContent: 'flex-end'}}>
              <Select placeholder="Model Type: All" size={"large"} style={{width: 180}} onChange={val => {this.setState({non_approved_model_type_filter: val}, ()=>this.filterNonApprovedData())}}>
                <Option className="manrope f-14 black-55 select-view" value="">Model Type: All</Option>
                <Option className="manrope f-14 black-55 select-view" value="Space">Space</Option>
                <Option className="manrope f-14 black-55 select-view" value="Product">Product</Option>
                <Option className="manrope f-14 black-55 select-view" value="Material">Material</Option>
                {this.state.is_super_artist ?
                  <Option className="manrope f-14 black-55 select-view" value="Complaint">Complaint</Option>
                  : ""}
              </Select>
              <Button 
                onClick={() => this.handleExportData('nonapproved')}
                disabled={this.state.filtered_non_approved_data.length === 0}
                className="save-button okay font-16"
                style={{color: 'white'}}
              >
                Export CSV
              </Button>
            </Col>
          </Row>
          <Col className='items-table' span={24}>
            <Table loading={{indicator: <LoadingOutlined/>, spinning: this.state.loading_non_approved}} columns={this.getInvoiceColumns()} dataSource={this.state.filtered_non_approved_data} pagination={{ pageSize: 7}}/>
          </Col>
          {/* Non-Approved Work Summary */}
          {this.getSummarySection(this.state.non_approved_summary, this.state.is_super_artist, this.state.hourly_rate, this.state.billing_type, true, this.state.agency_admin, this.state.agency_artist)}
        </TabPane>
      </Tabs>
    );
  }
}

export default InvoicingTimeLog;